import { MessageType } from "../Constants/MessageType";
/**
 * Accepts a message type and returns a humanised message severity.
 */
var humaniseMessageType = function (type) {
    switch (type) {
        case MessageType.INFO:
            return 'INFO';
        case MessageType.LOG:
            return 'LOG';
        case MessageType.WARNING:
            return 'WARNING';
        case MessageType.ERROR:
            return 'ERROR';
    }
};
export { humaniseMessageType };
//# sourceMappingURL=humaniseMessageType.js.map